import React from 'react';
import NavigationStepper, {
	NavigationStepperProps,
} from '../NavigationStepper';
import SubTabNavigationStepperItems from './SubTabNavigationStepperItems';

const SubTabNavigationStepper: React.FC<NavigationStepperProps> = props => {
	return (
		<NavigationStepper
			{...props}
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
};

export default SubTabNavigationStepper;
